export enum NetworkTestEnum {
    Excelente = 5,
    Bom = 4,
    Mediano = 3,
    Ruim = 2,
    Pessimo = 1,
}